import { PlusIcon, SearchBar, SmallButton } from "@wit/mpesa-ui-components";
import styleTheme from "@wit/mpesa-ui-components/lib/configs/theme.config";
import { FilterFuncts } from "@wit/mpesa-ui-components/lib/hooks/use-filters.hook";

import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { RoutesEnum } from "../../../../routes/routes.constants";
import { Column, Row } from "../../../../shared/shared.styled";

export enum ProductRecommendationsFiltersEnum {
  SEARCH = "search",
  STATUS = "status",
}

interface IProductRecommendationsFiltersProps extends FilterFuncts {
  hasSubmittedVersion?: boolean;
}

const ProductRecommendationsFilters = ({
  filters,
  clearFilter,
  updateFilter,
  hasSubmittedVersion = false,
}: IProductRecommendationsFiltersProps) => {
  const [t] = useTranslation();
  const history = useHistory();

  return (
    <ProductRecommendationsFilterContainer>
      <div style={{ flex: "30%", flexShrink: 0, flexGrow: 1 }} id={"search-product-recommendations"}>
        <SearchBar
          placeholderLabel={t("pages.productRecommendations.search")}
          value={
            filters.has(ProductRecommendationsFiltersEnum.SEARCH)
              ? (filters.get(ProductRecommendationsFiltersEnum.SEARCH) as string[])[0]
              : ""
          }
          onChange={e => {
            if (e.target.value) {
              updateFilter(ProductRecommendationsFiltersEnum.SEARCH, e.target.value, true);
            } else {
              clearFilter(ProductRecommendationsFiltersEnum.SEARCH);
            }
          }}
          clearValue={() => clearFilter(ProductRecommendationsFiltersEnum.SEARCH)}
        />
      </div>

      <Column
        style={{ flex: "30%", flexShrink: 0, flexGrow: 1, display: "flex", alignItems: "flex-end" }}
        id={"add-new-product-recommendation"}
      >
        <SmallButton
          disabled={hasSubmittedVersion}
          titleLabel={t("pages.productRecommendations.addProductRecommendation")}
          onClick={() => {
            history.push(RoutesEnum.ADD_PRODUCT_RECOMMENDATION);
          }}
          iconComponent={
            <SmallButtonIconContainer color={styleTheme.palette.vodafoneRed}>
              <PlusIcon />
            </SmallButtonIconContainer>
          }
        />
      </Column>
    </ProductRecommendationsFilterContainer>
  );
};

export default ProductRecommendationsFilters;

const ProductRecommendationsFilterContainer = styled(Row)`
  margin-bottom: 49px;
  margin-top: 48px;
  width: 100%;
  flex-wrap: wrap;
  gap: 24px;
  @media (max-width: 768px) {
    > div {
      flex: 45% !important;
    }
  }
`;

const SmallButtonIconContainer = styled("div")<{ color: string }>`
  width: 16px;
  height: 16px;
  stroke: ${props => props.color};

  svg {
    width: 16px;
    height: 16px;
    stroke: ${props => props.color};
  }
`;
